import { render, staticRenderFns } from "./LogisticsTrack.vue?vue&type=template&id=ce56c6f0&"
import script from "./LogisticsTrack.vue?vue&type=script&lang=js&"
export * from "./LogisticsTrack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports